export default {
    language: '简体中文',
    search: {
        name: '搜索产品',
        by: '关键词(型号)',
        placeholder: '请输入型号'
    },
    topNavigation: [
        // {name: '新闻', active: '', path: '/news'},
        {
            name: '联系我们', active: '', path: '/contact', way: [
                {name: '邮件', active: 'margin-top: 20px;font-size: 13px', icon: 'el-icon-message', value: 'Ming.yeung@cheier.com'},
                {name: '电话', active: 'margin-top: 20px;font-size: 13px;line-height: 1.6', icon: 'el-icon-phone-outline', value: '杨生 13798452148', value2: '+86-755-28340382'},
                {name: '传真', active: 'margin-top: 20px;font-size: 13px', icon: 'el-icon-receiving', value: '+86-755-28340986'},
                {
                    name: '地址',
                    active: 'font-size: 11px;padding: 10px 5px;line-height: 1.4',
                    icon: 'el-icon-location-outline',
                    value: '深圳市坪山区龙田街道龙田社区吓陂村4-1号'
                }
            ]
        },
        {name: '网站地图', active: '', path: '/site_map'}
    ],
    headNavigation: [
        {name: '产品', active: '', path: '/products'},
        {name: '技术', active: '', path: '/technology'},
        {name: '公司', active: '', path: '/company'}
        // {name:'IR Information',active: '',path: '/ir'}
    ],
    botNavigation: [
        {
            title: '产品', path: '/products', element: [
                {name: '搜索产品', active: '', path: '/products/search'},
    ]
},
{
    title: '技术', path: '/technology', element: [
        {name: '加工实例', active: '', path: '/technology/processing_case'}
]
},
{
    title: '公司', path: '/company', element: [
        {name: '简介', active: '', path: '/company/outline'},
        {name: '证书',active: '', path: '/company/certificate'},
        {name: '历史', active: '', path: '/company/history'},
        {name: '环境政策', active: '', path: '/company/environment'}
]
},
// {title:'IR Information',path: '/ir',element:[
//         {name:'Research Report',active:'',path: '/'},
//         {name:'Financial Report',active:'',path: '/'},
//         {name:'Business Report',active:'',path: '/'}
//     ]},
// {title:'News & Events',path: '/',element:[
//         {name:'Products',active:'',path: '/'},
//         {name:'Events',active:'',path: '/'},
//         {name:'Company',active:'',path: '/'}
//     ]},
{
    title: '其他', element: [
    // {name: '新闻', active: '', path: '/news'},
    {name: '联系我们', active: '', path: '/contact'},
    {name: '网站地图', active: '', path: '/site_map'}
]
},
],
    processingCaseDetails: {
        name: '加工实例详情', path: '/technology/processing_case_details',
        product:'使用的工具',
        material:'材质',
        materialSize:'工件尺寸',
        processingTime:'加工时长',
        cuttingData:'切削数据',
        coolant:'切削液',
        comment:'评论'
    },
languages: [
    {code: 'zhTW', name: '繁体中文'},
    {code: 'en', name: '英文'}
],
    something: [
    {title: '产品', details: '介绍我们的产品信息', active: '', path: '/products'},
    {
        title: '技术',
        details: '处理案例介绍和技术数据',
        active: '',
        path: '/technology'
    },
    {title: '公司', details: '关于我们', active: '', path: '/company'}
    // {title:'IR Information',details:'Investor Information & Various financial statements',active: 'pointer-events: none;',path: '/ir'}
],
    routeMap: [
    {name: '主页', path: '/'},
    {
        name: '产品', path: '/products', son: [
            {name: '产品搜索', path: '/products/search'},
        ]
    },
    {
        name: '技术', path: '/technology', son: [
            {name: '加工实例', path: '/technology/processing_case'}
        ]
    },
    {
        name: '公司', path: '/company', son: [
            {name: '简介', path: '/company/outline'},
            {name: '证书', path: '/company/certificate'},
            {name: '历史', path: '/company/history'},
            {name: '环境政策', path: '/company/environment'},
        ]
    },
    {
        name: '其他', son: [
            // {name: '新闻', path: 'news'},
            {name: '联系我们', path: '/contact'},
            {name: '网站地图', path: '/site_map'},
        ]
    }
],
    company: [
    {
        name: '简介', active: '', path: '/company/outline', imageUrl: '../../../public/static/outline.png',
        table: [
            {title: '公司', information: '深圳市卓曦尔科技有限公司'},
            {title: '总裁', information: '杨逸明'},
            {
                title: '总部',
                information: '深圳市坪山区龙田街道龙田社区吓陂村4-1号'
            },
            {title: '成立时间', information: '1999年'},
            {title: '成立资本', information: '500万元'},
            {title: '企业简介', information: '刀具的制造和销售'},
            {title: '产品', information: '高科技产业用整体硬质合金立铣刀'}
        ]
    },
    {
        name:'证书',active: '',path: '/company/certificate',imageUrl: '../../../public/static/certificate.png'
    },
    {
        name: '历史', active: '', path: '/company/history', imageUrl: '../../../public/static/history.png',
        table: [
            {year: 1999, event: '成立于香港'},
            {year: 2016, event: '于坪山设立3000m²厂区'},
            {year: 2017, event: '成功研发并申请拥有以下计算机软件著作权' +
                    '~《阶梯轮廓铣刀快速成形软件V1.0》' +
                    '~《低速高进弧立铣刀操作控制系统V1.0》' +
                    '~《左旋左切的T形钨钢成形控制系统V1.0》' +
                    '~《左右错齿的钨钢铣刀快速成形软件V1.0》' +
                    '~《一种圆鼻铣削钨钢刀具成形控制软件V1.0》' +
                    '~《一种具有左旋右切的铣削钨钢控制系统V1.0》' +
                    '~《卓曦尔超高硬度钨钢铣刀控制系统软件V1.0》' +
                    '~《卓曦尔特种加工钨钢刀具自动控制系统软件V1.0》'},
            {year: 2019, event: '成功申请以下实用新型专利' +
                    '~《一种成型钻铣刀》' +
                    '~《一种PCD内孔成型刀》' +
                    '~《一种PCD组合外圆成型刀》' +
                    '~《一种数控车床快捷万能刀杆》' +
                    '~成功研发并申请拥有以下计算机软件著作权' +
                    '~《卓溪尔多层T槽钨钢刀具成型控制软件V1.0》' +
                    '~《卓曦尔成型钻铣削钨钢刀具成型控制软件V1.0》' +
                    '~《卓曦尔新型平底钻钨钢刀具成型控制软件V1.0》'}
        ]
    },
    {
        name: '环境政策',
        active: '',
        path: '/company/environment',
        imageUrl: '../../../public/static/environment.png',
        intro: 'CHEIER TOOL致力于开发和制造高附加值和高品质的产品，' +
            '以有效利用自然资源。为了社会的发展，我们不断提供有价值的产品和技术服务。',
        content: [
            {content: '我们推动环境管理体系的持续改善。'},
            {content: '我们努力防止环境污染，如环境噪音、震动以及由于我们的经营活动排放气体和排水造成的空气和水污染。'},
            {content: '我们致力于环境保护，遵守与环境有关的法律、法规和协议。'},
            {content: '我们努力在生产和办公活动中减少浪费，节约自然资源和能源。'},
            {content: '为了实现环境管理体系，我们通过制定环境目标和目标，在实施计划的基础上推动活动。'},
            {content: '环境管理体系应以书面形式由管理层告知每位员工，并应其要求向公众披露。'},
        ],
        author: '杨逸明',
        date: '2023年11月12号'
    }
],
    series: [
    {name: 'CuttingTool'},
    {name: 'Diamond'},
    {name: 'Optical'},
    {name: 'Superhard Material'}
]
}